import { render, staticRenderFns } from "./Cursos.vue?vue&type=template&id=2fc485f7&scoped=true"
import script from "./Cursos.vue?vue&type=script&lang=js"
export * from "./Cursos.vue?vue&type=script&lang=js"
import style0 from "./Cursos.vue?vue&type=style&index=0&id=2fc485f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc485f7",
  null
  
)

export default component.exports